import BaseApi, { FetchMethodType } from 'api/BaseApi';
import {
  IApplicationDocumentUploadItem,
  IPreparedApplicationDocumentUploadItem,
} from 'api/types';

interface ICreateApplicationDocumentUploadParams {
  applicationId: string;
  taskId: string;
  items: IApplicationDocumentUploadItem[];
}

interface IPrepareApplicationDocumentUploadItemResponse {
  items: IPreparedApplicationDocumentUploadItem[];
}

export interface IApplicationDocumentUploadsApi {
  create(params: ICreateApplicationDocumentUploadParams): Promise<IPreparedApplicationDocumentUploadItem[]>;
}

export default class ApplicationDocumentUploadsRestApi extends BaseApi implements IApplicationDocumentUploadsApi {
  public async create(
    params: ICreateApplicationDocumentUploadParams,
    signal?: AbortSignal,
  ): Promise<IPreparedApplicationDocumentUploadItem[]> {
    const { items } = await this.fetch<
      IPrepareApplicationDocumentUploadItemResponse
    >('/application-document-uploads', {
      method: FetchMethodType.POST,
      body: params,
      signal,
    });

    return items;
  }
}
